import { FormContentView } from '../../FormsUI/FormsUI Components/Containers/FormContentView';
import { FormTextView } from '../../FormsUI/FormsUI Components/Controls/FormTextView';
import { FormsStyles } from '../../FormsUI/FormsUI';

import React from 'react';
import PropTypes from 'prop-types';

export class WrappingTextFormDetail extends React.Component {

    constructor(props) {
        super(props);

        this.textFieldUpdated = this.textFieldUpdated.bind(this);
    }

    textFieldUpdated(value) {
        this.props.formDetail.form.valueUpdated(this.props.formDetail.identifier, value);
        this.props.renderErrors();
    }

    shouldComponentUpdate(nextProps) {
        if(nextProps.formDetail.editingValue !== this.props.formDetail.editingValue){
            return true;
        }

        if(nextProps.isSubcell !== this.props.isSubcell){
            return true;
        }

        return true;
    }

    render() {
        let subcells = this.props.renderSubcells();
        let isMandatory = this.props.formDetail.form.isMandatory(this.props.formDetail.identifier);
        let value = this.props.formDetail.editingValue == null || this.props.formDetail.editingValue == undefined ? undefined : this.props.formDetail.editingValue.toString();
        let textField = (<FormTextView value={value} isLarge={this.props.isLarge} onChange={this.textFieldUpdated} placeholder={isMandatory ? 'Required' : 'Optional'} subCellbackgroundColor={FormsStyles.backgroundColor}/>);
        
        return (<FormContentView identifier={this.props.formDetail.identifier} isSubcell={this.props.isSubcell} titleString={this.props.formDetail.title} isMandatory={isMandatory} validation={this.props.errorLabels} detailString={this.props.formDetail.detail} bottomControl={textField} unitText={this.props.formDetail.unitText} subcell={subcells} showHover={this.props.showHover}/>);
    }
}

WrappingTextFormDetail.propTypes = {
    formDetail: PropTypes.object.isRequired,
    showHover: PropTypes.bool.isRequired,
    isSubcell: PropTypes.bool.isRequired,
    renderErrors: PropTypes.func.isRequired,
    renderSubcells: PropTypes.func.isRequired,
    errorLabels: PropTypes.array.isRequired,
    hasError: PropTypes.bool.isRequired,
    isLarge: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/waferJS/Form To FormsUI/Subclasses/WrappingTextFormDetail.js